export default function HowToBuy() {
  const steps = [
    {
      num: '01',
      icon: 'ri-search-line',
      title: 'Escolha um Produto',
      desc: 'Navegue pela nossa Hoobuy Spreadsheet e encontre o produto que deseja entre mais de 10.000 opções.',
    },
    {
      num: '02',
      icon: 'ri-file-copy-line',
      title: 'Copie o Link',
      desc: 'Copie o link do produto desejado diretamente da nossa planilha organizada por categoria.',
    },
    {
      num: '03',
      icon: 'ri-shopping-cart-line',
      title: 'Adicione ao Carrinho',
      desc: 'Cole o link na plataforma Hoobuy e adicione o produto ao seu carrinho de compras.',
    },
    {
      num: '04',
      icon: 'ri-bank-card-line',
      title: 'Finalize o Pagamento',
      desc: 'Escolha entre diversas formas de pagamento seguro e conclua sua compra com proteção.',
    },
    {
      num: '05',
      icon: 'ri-truck-line',
      title: 'Receba sua Encomenda',
      desc: 'Acompanhe o envio e receba seu produto no conforto da sua casa com frete rápido.',
    },
  ];

  return (
    <section id="guia" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-4">
            Passo a Passo
          </span>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950">
            Como Comprar na Hoobuy
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Um guia simples e rápido para você começar a comprar usando a melhor Hoobuy Spreadsheet em português.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {steps.map((step, i) => (
            <div key={step.num} className="relative group">
              <div className="rounded-lg bg-background-50 border border-background-200/60 p-5 md:p-6 h-full hover:border-primary-200/60 transition-all duration-300">
                <span className="text-3xl font-heading font-bold text-primary-200 group-hover:text-primary-400 transition-colors">
                  {step.num}
                </span>
                <div className="mt-4 w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                  <i className={`${step.icon} text-primary-600`}></i>
                </div>
                <h3 className="mt-3 text-sm md:text-base font-semibold text-foreground-950">{step.title}</h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 z-10 text-primary-300">
                  <i className="ri-arrow-right-s-line text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}